import { Component } from 'react';
import { connect } from 'react-redux';
import { NavMarker } from 'react-rhumb';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Nabi... Remove this comment to see the full error message
import HubSpotOnlyAppCookieLogin from 'Nabisco/app/HubSpotOnlyAppCookieLogin';
import { stringify } from 'hub-http/helpers/params';
import GoogleLoginConfirmation from './GoogleLoginConfirmation';
import SsoRequiredAuthStatuses from 'LoginUI/constants/SsoRequiredAuthStatuses';
import GoogleLoginDao from 'LoginUI/data/GoogleLoginDao';
import LoginDao from 'LoginUI/data/LoginDao';
import googleLoginNonce from 'LoginUI/lib/googleLoginNonce';
import LoginFailureHandlerFactory from 'LoginUI/lib/LoginFailureHandlerFactory';
import { isLocalhostAuthUrl } from 'LoginUI/utils/urls';
import TwoFactorAuthStatuses from 'LoginUI/constants/TwoFactorAuthStatuses';
import ConfirmToLoginAuthStatuses from 'LoginUI/constants/ConfirmToLoginAuthStatuses';
import { setTwoFactorMethod, setCredentials, setUsePasskeyFor2FA, setPasskeyAaguids } from 'LoginUI/actions';
import { jsx as _jsx } from "react/jsx-runtime";
const loginDao = new LoginDao();
const appCookieLogin = new HubSpotOnlyAppCookieLogin({
  loginRequest: loginDao.googleLogin.bind(loginDao),
  passThroughFallback: true
});
const googleLoginDao = new GoogleLoginDao();
class GoogleLoginConfirmationLanding extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      loginPortalId: undefined,
      loginRedirectUrl: ''
    };
    this.onFinish = responses => {
      const response = responses[0];
      switch (response.status) {
        case TwoFactorAuthStatuses.TWO_FACTOR_REQUIRED:
          return this.handleTwoFactorRequired(response);
        case ConfirmToLoginAuthStatuses.SUSPICIOUS_USER_MUST_CONFIRM:
          return this.handleSuspiciousUserMustConfirm(response);
        case SsoRequiredAuthStatuses.SSO_LOGIN_REQUIRED:
          return this.handleSsoRequired(response);
        default:
          return appCookieLogin.redirectOnLoginSuccess(responses);
      }
    };
    this.handleTwoFactorRequired = response => {
      const {
        loginPortalId,
        loginRedirectUrl
      } = this.state;
      const {
        email,
        token,
        backupCodesEnabled,
        allowedMethods,
        hasPasskeySetup,
        passkeyAaguids
      } = response;
      this.props.setUsePasskeyFor2FA(hasPasskeySetup || false);
      this.props.setPasskeyAaguids(passkeyAaguids);
      this.props.setTwoFactorMethod(token, backupCodesEnabled, allowedMethods);
      this.props.setCredentials({
        email
      });
      const nextPath = `/two-factor?${stringify({
        loginPortalId,
        loginRedirectUrl
      })}`;
      this.props.history.push(nextPath);
    };
    this.handleSuspiciousUserMustConfirm = response => {
      const {
        loginPortalId,
        loginRedirectUrl
      } = this.state;
      const {
        token,
        email
      } = response;
      this.props.setUsePasskeyFor2FA(false);
      this.props.setTwoFactorMethod(token, false, []);
      this.props.setCredentials({
        email
      });
      const nextPath = `/confirm-to-login?${stringify({
        loginRedirectUrl,
        loginPortalId
      })}`;
      this.props.history.push(nextPath);
    };
    this.handleSsoRequired = response => {
      const {
        loginRedirectUrl,
        loginPortalId
      } = this.state;
      const {
        hubId
      } = response;
      const nextPath = `/sso?${stringify({
        loginPortalId: loginPortalId || hubId,
        required: true,
        loginRedirectUrl
      })}`;
      return this.props.history.push(nextPath);
    };
    this.onGoogleLoginClick = (fragmentState, triggerFailure) => {
      const {
        client,
        loginPortalId,
        loginRedirectUrl,
        rememberLogin
      } = fragmentState;
      const credentials = {
        client,
        loginPortalId,
        loginRedirectUrl,
        rememberLogin
      };
      googleLoginDao.initialize(credentials).then(googleLoginNonce.storeAndRedirect).catch(LoginFailureHandlerFactory.createRavenReporter('Google initialization failed', triggerFailure, this.props.history.push));
    };
    this.loginSubmit = (idToken, fragmentState, triggerFailure) => {
      const {
        client,
        loginPortalId,
        loginRedirectUrl,
        googleLoginRedirectUrl,
        rememberLogin
      } = fragmentState;
      this.setState({
        loginPortalId,
        loginRedirectUrl: googleLoginRedirectUrl || loginRedirectUrl
      });
      const credentials = {
        idToken,
        client,
        loginPortalId,
        loginRedirectUrl: googleLoginRedirectUrl || loginRedirectUrl,
        nonce: googleLoginNonce.get(),
        rememberLogin
      };
      const extraSearchObject = {
        loginPortalId,
        loginRedirectUrl: googleLoginRedirectUrl || loginRedirectUrl
      };
      if (isLocalhostAuthUrl(loginRedirectUrl)) {
        window.location.href = `${loginRedirectUrl}?google=${btoa(JSON.stringify(credentials))}`;
      } else {
        appCookieLogin.login(credentials).then(this.onFinish).catch(LoginFailureHandlerFactory.createRavenReporter('Google login failed', triggerFailure, this.props.history.push, extraSearchObject));
      }
    };
  }
  componentDidMount() {
    appCookieLogin.loginPrep();
  }
  render() {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "GOOGLE_LOGIN_REDIRECT_LOAD",
      children: /*#__PURE__*/_jsx(GoogleLoginConfirmation, {
        onGoogleLoginClick: this.onGoogleLoginClick,
        onLoginSubmit: this.loginSubmit
      })
    });
  }
}
export default connect(null, {
  setTwoFactorMethod,
  setCredentials,
  setUsePasskeyFor2FA,
  setPasskeyAaguids
})(GoogleLoginConfirmationLanding);